import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthService } from "../../service/AuthService";
import { AppContext } from "../../HomePage";
import AuthLayout from "./AuthLayout";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";

// SSO entry point. The Shopify app deep-links here with a one-time, short-lived
// code: /#/sso?code=<code>. We exchange the code for a session payload on the
// backend (single-use; the long-lived token never travels in the URL) and
// establish a logged-in session without a password — then redirect.
export default function Sso() {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const [failed, setFailed] = useState(false);
    const started = useRef(false);

    useEffect(() => {
        if (started.current) return;
        started.current = true;

        const code = params.get('code');
        if (!code) {
            setFailed(true);
            return;
        }

        // Optional deep-link target; defaults to the product page.
        const next = params.get('next') || '/product';

        // Optional campaign to pre-select (the deep-link's store maps to one
        // campaign). Stashed for App.js to consume once campaigns load.
        const campaign = params.get('campaign');
        if (campaign) {
            sessionStorage.setItem('pr_sso_campaign', campaign);
        }

        AuthService.apiPost('users/sso_exchange/', { code })
            .then((res) => {
                AuthService.setUserAndToken(res);
                navigate(next);
            })
            .catch(() => {
                setFailed(true);
            });
    }, [params, navigate]);

    const {t} = React.useContext(AppContext);

    return <AuthLayout title={failed ? t('login.sso_failed_title') : t('login.sso_title')}
                       subtitle={failed ? t('login.sso_failed_detail') : t('login.sso_signing_in')}>
        {failed ?
            <Button label={t('login.back_to_login')} icon="pi pi-sign-in" className="auth-ux__submit"
                    onClick={() => navigate("/login")}/> :
            <div className="auth-ux__sso-spinner"><ProgressSpinner strokeWidth="4" animationDuration=".5s"/></div>}
    </AuthLayout>;
}
